import React from "react";
import { useTranslation } from "react-i18next";

function CoomingSoon() {
    const { t } = useTranslation();
    return (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
            <h4>{t("Coming soon...")}</h4>
        </div>
    );
}

export default CoomingSoon;
